import {getApiUrl} from "./client";
import {FEEDBACK_CONSENT_VERSION} from "../components/feedback/helpers";
import type {FeedbackContext, FeedbackType} from "../components/feedback/types";

export type FeedbackSubmission = FeedbackContext & {
    feedbackType: FeedbackType;
    subject: string;
    message: string;
    email?: string;
    appVersion: string;
    browser: string;
    device: string;
    willingToShareRawData: boolean;
    rawDataFile?: File | null;
};

export type FeedbackSubmitResponse = {
    status: string;
    feedback: {
        id: number;
        feedbackType: FeedbackType;
        status: string;
        willingToShareRawData: boolean;
        consentVersion: string | null;
        rawDataSizeBytes: number | null;
        createdAt: string;
    };
};

const FEEDBACK_ENDPOINT = '/api/feedback';

export const submitFeedback = async (submission: FeedbackSubmission) => {
    const formData = new FormData();
    formData.append('feedbackType', submission.feedbackType);
    formData.append('subject', submission.subject);
    formData.append('message', submission.message);
    if (submission.email) formData.append('email', submission.email);
    formData.append('pageRoute', submission.pageRoute);
    formData.append('pageUrl', submission.pageUrl);
    if (submission.entityType) formData.append('entityType', submission.entityType);
    if (submission.entityId) formData.append('entityId', submission.entityId);
    formData.append('appVersion', submission.appVersion);
    formData.append('browser', submission.browser);
    formData.append('device', submission.device);
    formData.append('willingToShareRawData', submission.willingToShareRawData ? 'true' : 'false');
    formData.append('consentVersion', submission.willingToShareRawData ? FEEDBACK_CONSENT_VERSION : '');

    if (submission.rawDataFile) {
        formData.append('rawDataFile', submission.rawDataFile, submission.rawDataFile.name);
    }

    const response = await fetch(getApiUrl(FEEDBACK_ENDPOINT), {
        method: 'POST',
        headers: {
            'Accept': 'application/json'
        },
        body: formData
    });

    if (!response.ok) {
        let message = `Feedback submission failed with ${response.status}`;

        try {
            const payload = await response.json();
            if (payload?.message) {
                message = payload.message;
            }
        } catch (error) {
            // Ignore parse errors and surface the HTTP status instead.
        }

        throw new Error(message);
    }

    return await response.json() as FeedbackSubmitResponse;
};
